import { render, staticRenderFns } from "./StaffMemberSetup.vue?vue&type=template&id=5c704304&"
import script from "./StaffMemberSetup.vue?vue&type=script&lang=js&"
export * from "./StaffMemberSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports